import * as actions from '../actions/constants';
import channelReducer from './channelReducer';
import { getSortOptionByValue } from '../../searchResult/model/query/sortOptions';
import { getPropertyTypeFromId } from '../../../shared/model/constants/propertyTypes';

export default function refinements(state = {}, action) {
  const { filters } = state;
  switch (action.type) {
    case actions.OPEN_REFINEMENT:
      return { ...state, filters: action.value, isOpen: true };
    case actions.CLOSE_REFINEMENT:
      return { ...state, isOpen: false };
    case actions.UPDATE_CHANNEL:
      return { ...state, filters: channelReducer(filters, action) };
    case actions.UPDATE_LOCATIONS:
      return { ...state, filters: { ...filters, locations: action.value } };
    case actions.UPDATE_CURRENT_LOCATION:
      return { ...state, filters: { ...filters, currentLocation: action.value } };
    case actions.UPDATE_MIN_PRICE:
      return { ...state, filters: { ...filters, minPrice: action.value } };
    case actions.UPDATE_MAX_PRICE:
      return { ...state, filters: { ...filters, maxPrice: action.value } };
    case actions.UPDATE_MIN_FLOOR_AREA:
      return { ...state, filters: { ...filters, minFloorArea: action.value } };
    case actions.UPDATE_MAX_FLOOR_AREA:
      return { ...state, filters: { ...filters, maxFloorArea: action.value } };
    case actions.UPDATE_MIN_SITE_AREA:
      return { ...state, filters: { ...filters, minSiteArea: action.value } };
    case actions.UPDATE_MAX_SITE_AREA:
      return { ...state, filters: { ...filters, maxSiteArea: action.value } };
    case actions.UPDATE_PROPERTY_TYPES:
      return { ...state, filters: { ...filters, propertyTypes: action.value.map(getPropertyTypeFromId) } };
    case actions.UPDATE_SORT_BY:
      return { ...state, filters: { ...filters, sortObject: getSortOptionByValue(action.value) } };
    case actions.UPDATE_KEYWORDS:
      return { ...state, filters: { ...filters, keywords: action.value } };
    case actions.UPDATE_SEARCH_WITHIN:
      return { ...state, filters: { ...filters, searchWithin: action.value } };
    case actions.UPDATE_TENURE_TYPE:
      return { ...state, filters: { ...filters, tenureType: action.value } };
    case actions.UPDATE_ENERGY_EFFICIENCY:
      return { ...state, filters: { ...filters, energyEfficiency: action.value } };
    case actions.UPDATE_PARKING_SPACES:
      return { ...state, filters: { ...filters, numParkingSpaces: action.value } };
    case actions.CLEAR_ALL:
      return {
        ...state,
        filters: {
          channel: filters.channel,
          locations: filters.locations,
          searchWithin: 'includesurrounding',
          propertyTypes: [],
        },
      };
    default:
      return state;
  }
}
